export default "__VITE_ASSET__CMUrUGU4__"